import { atom } from 'recoil';

export const calendarState = atom({
  key: 'calendarState', // unique ID (with respect to other atoms/selectors)
  default: 'block',
  // default value (aka initial value)
});
